import React from 'react';
import { withAuthenticator } from '@aws-amplify/ui-react';
import { Row, Col } from 'react-bootstrap';
import clsx from 'clsx';
import LaunchpadCard from '../../components/LaunchpadCard';
import Images from '../../assets/images';
import styles from './styles.module.scss';

const LAUNCHPAD_ITEMS = [
  {
    icon: Images.IconRoute,
    title: 'Transport & Logistics',
    description: 'Monitor and optimise transport activity, routes and utilisation to improve efficiency, reliability and system flow.',
    to: '/transport',
  },
  {
    icon: Images.IconChartLine,
    title: 'Dashboard Analytics',
    description: 'View rich insights across activity, demand, variation, performance and outcomes to support confident, data-led decisions.',
    to: '/dashboard-analytics',
  },
  {
    icon: Images.IconXray,
    title: 'Diagnostic Imaging',
    description: 'Monitor live capacity, demand and RTT reporting insights. Identify bottlenecks and delays end to end, supporting optimised diagnostic pathways.',
    to: '/imaging',
    disabled: true,
  },
  {
    icon: Images.IconCost,
    title: 'Cost Per Test',
    description: 'Improve laboratory cost management through dynamic, activity-based costing insights that support financial planning and resource utilisation.',
    to: '/cost-per-test',
    disabled: true,
  },
];

const Launchpad = () => {
  return (
    <div className={clsx(styles['launchpad-wrapper'])}>
      <Row className={styles['launchpad-grid']}>
        {LAUNCHPAD_ITEMS.map((item) => (
          <Col key={item.to} xs={12} sm={6} lg={3} className={styles['launchpad-col']}>
            <LaunchpadCard
              icon={item.icon}
              title={item.title}
              description={item.description}
              to={item.to}
              disabled={item.disabled}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default withAuthenticator(Launchpad, {
  hideSignUp: true,
});
